export default __webpack_public_path__ + "static/media/Rosalie_9781408340349.61c292c9.jpg";